<template>
    <section class="quote light yellow">
        <circles-layout></circles-layout>

        <v-quote>Als practoraat binnen MindLabs willen we niet alleen scholen en bedrijven heel nauw met elkaar verbinden, maar ook de overheid en het maatschappelijk werkveld. Zo kunnen we toekomstige maatschappelijke uitdagingen samen oplossen met interactieve technologie.</v-quote>

        <v-author>- Erdin&ccedil;&nbsp;Sa&ccedil;an, Practor MindLabs</v-author>
    </section>
</template>

<style lang="scss" scoped>
    // see /static/scss/pages/_tekst.scss
</style>

<script>
    import Circles from '@/app/components/circles';
    import Quote from '@/app/components/quotations';
    import QuoteAuthor from '@/app/components/quotation-author';

    export default {
        name: 'RegioQuote',
        meta: {
            title: 'Regio',
            color: '#FEBE06'
        },
        components: {
            'circles-layout': Circles,
            'v-quote': Quote,
            'v-author': QuoteAuthor
        },
        methods: {
            focus()
            {
                // console.log( 'animateIn' );
            }
        }
    };
</script>
